module.exports = __webpack_public_path__ + "media/images/newsletter_icon-5420073a270d745f1e1cebfbae6118da.svg";